// extracted by mini-css-extract-plugin
export default {"loadingContainer":"styles_loadingContainer__ksYMH","lds_ring":"styles_lds_ring__IcqHd"};